export default __webpack_public_path__ + "static/media/shirt.a8c956cb.png";